export const mapLocationsToOptions = (locations = []) => {
  return locations.filter(l => l.is_active === 1)
    .map(l => ({
      label: l.location_name,
      value: l.location_id,
    }));
};

export const mapDoorsToOptions = (doors = []) => {
  return doors.filter(d => d.visible === 1)
    .map(d => ({
      label: d.name,
      value: d.door_id,
    }));
};

export const mapAgenciesToOptions = (agencies = []) => {
  return agencies.filter(a => a.is_active === 1)
    .map(a => ({
      label: a.name,
      value: a.agency_id,
    }));
};

export const mapEmployeesToOptions = (employees = []) => {
  return employees.filter(e => e.is_active === 1)
    .map(e => ({
      label: e.full_name,
      value: e.employee_id,
    }));
};

export const mapContainerClassesToOptions = (containerClasses = []) => {
  return containerClasses.map(c => ({
    label: c.content_class,
    value: c.content_class,
  }));
};

export const mapCustomersToOptions = (customers = []) => {
  return customers.map(c => ({
    label: c.name,
    value: c.id,
  }));
};
